import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesignsRequest } from '../../models/surplus-lines-plan-design.model';

@Component({
  selector: 'app-student-loan-repayment',
  standalone: false,
  templateUrl: './student-loan-repayment.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class StudentLoanRepaymentComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<StudentLoanRepaymentComponent>);
  SLRDurationOptions: string[] = [];
  SLRAmountOptions: string[] = [];
  SLRDuration: string = '';
  SLRAmount: string = '';
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  cost: string = '';
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.SLRDurationOptions = this.getStudentLoanRepaymentDurationOptions();
    this.SLRAmountOptions = this.getStudentLoanRepaymentAmountOptions();
    if(this.SLRAmount == ''){
      this.SLRAmount = this._oss.currentQuoteOptions?.SLRAmountDefault as string;
    }
    if(this.SLRDuration == ''){
      this.SLRDuration = this._oss.currentQuoteOptions?.SLRDurationDefault as string;
    }

    this.updateCost();
  }

  getStudentLoanRepaymentAmountOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.SLRAmountOptions.replaceAll('; ', ';').split(';');
  }

  getStudentLoanRepaymentDurationOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.SLRDurationOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.SLRAmount = this.SLRAmount;
    this.additionalPlanDesignRequest.SLRDuration = this.SLRDuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion(){
    if(this._oss.currentQuoteOptions?.SLRInclusion == 'Y'){
      return true;
    }
    return false;
  }

  yes() {
    this.dialogRef.close({ SLRDuration: this.SLRDuration, SLRAmount: this.SLRAmount, cost: this.cost });
  }

  no() {
    this.dialogRef.close(false);
  }
}
